import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/cpyManage',
    meta: { title: '成品油信息管理' },
    component: Layout,
    redirect: '/cpyManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '成品油信息管理', activeMenu: '/cpyManage' },
        component: () => import('@/views/cpyManage/Index.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增成品油信息',
          activeMenu: '/cpyManage'
        },
        component: () => import('@/views/cpyManage/CpyAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑成品油信息',
          activeMenu: '/cpyManage'
        },
        component: () => import('@/views/cpyManage/CpyAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '成品油信息详情',
          activeMenu: '/cpyManage'
        },
        component: () => import('@/views/cpyManage/CpyDetail.vue')
      }

    ]
  },
  {
    path: '/cpyCategory',
    meta: { title: '成品油类型管理' },
    component: Layout,
    redirect: '/cpyCategory/list',
    children: [
      {
        path: 'list',
        meta: { title: '成品油类型管理', activeMenu: '/cpyCategory' },
        component: () => import('@/views/cpyCategory/Index.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增成品油类型',
          activeMenu: '/cpyCategory'
        },
        component: () => import('@/views/cpyCategory/CpyCategoryAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑成品油类型',
          activeMenu: '/cpyCategory'
        },
        component: () => import('@/views/cpyCategory/CpyCategoryAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '成品油类型详情',
          activeMenu: '/cpyCategory'
        },
        component: () => import('@/views/cpyCategory/CpyCategoryDetail.vue')
      }

    ]
  }
]
